(() => {
  const bars = Array.from(document.querySelectorAll('[data-pdp-sticky-bar].pdp-sticky-atc-bar'));
  if (!bars.length) return;

  bars.forEach((bar) => {
    'use strict';

    const vtoBtn = document.querySelector('[data-pdp-vto]');
    const productForm = document.querySelector('form.ProductForm');

    function getMainAtcBtn() {
      return productForm ? productForm.querySelector('.ProductForm__AddToCart') : null;
    }
    function getMainLensBtn() {
      return productForm
        ? productForm.querySelector('.pdp-redesign-ctas lensadvizor-quick-buy, .ProductForm__LensSelectorButton')
        : null;
    }

    const btnFrameOnly = bar.querySelector('[data-pdp-sticky-frame-atc]');
    const btnFrameOnlyText = bar.querySelector('[data-pdp-sticky-frame-text]');
    const btnCustomise = bar.querySelector('[data-pdp-sticky-customise]');
    const stickyVariantSelect = bar.querySelector('[data-pdp-sticky-variant-select]');
    const thumbImg = bar.querySelector('.pdp-sticky-atc-bar-thumb img');

    const DEFAULT_FRAME_TEXT = (btnFrameOnly && btnFrameOnly.getAttribute('data-default-text')) || 'Frame only';
    const DEFAULT_UNAVAILABLE_TEXT = (btnFrameOnly && btnFrameOnly.getAttribute('data-unavailable-text')) || 'Unavailable';

    const productData = window?.__pdpStickyAtcBarProductJson || null;
    const variants = productData && productData.variants ? productData.variants : [];

    function setStickyDependentOffsets(isBarVisible) {
      const root = document.documentElement;
      root.classList.toggle('pdp-sticky-atc-bar-visible', isBarVisible);

      const baseOffset = 18;
      if (vtoBtn) {
        if (!isBarVisible) {
          root.style.setProperty('--pdp-vto-bottom', `${baseOffset}px`);
        } else {
          const h = bar && bar.offsetHeight ? bar.offsetHeight : 0;
          root.style.setProperty('--pdp-vto-bottom', `${h + baseOffset}px`);
        }
      }

      if (!isBarVisible) {
        root.style.setProperty('--klaviyo-teaser-bottom', '0px');
        return;
      }

      const stickyHeight = bar && bar.offsetHeight ? bar.offsetHeight : 0;
      root.style.setProperty('--klaviyo-teaser-bottom', `${stickyHeight}px`);
    }

    function findVariant(id) {
      for (let i = 0; i < variants.length; i += 1) {
        if (variants[i].id === id) return variants[i];
      }
      return null;
    }

    function syncStickyButtonStates(variant) {
      if (!btnFrameOnly) return;
      const lang = window.languages || {};
      const textTarget = btnFrameOnlyText || btnFrameOnly;

      if (!variant) {
        btnFrameOnly.setAttribute('disabled', 'disabled');
        btnFrameOnly.setAttribute('data-variant-id', '');
        btnFrameOnly.classList.remove('klaviyo-bis-trigger');
        textTarget.textContent = lang.productFormUnavailable || DEFAULT_UNAVAILABLE_TEXT;
      } else if (variant.available) {
        btnFrameOnly.removeAttribute('disabled');
        btnFrameOnly.setAttribute('data-variant-id', variant.id);
        btnFrameOnly.classList.remove('klaviyo-bis-trigger');
        btnFrameOnly.classList.remove('is-sold-out');
        textTarget.textContent = DEFAULT_FRAME_TEXT;
      } else {
        btnFrameOnly.removeAttribute('disabled');
        btnFrameOnly.setAttribute('data-variant-id', variant.id);
        btnFrameOnly.classList.add('klaviyo-bis-trigger');
        btnFrameOnly.classList.add('is-sold-out');
        textTarget.textContent = lang.productFormSoldOut || 'Sold out';
      }

      if (btnCustomise) {
        const purchasable = !!(variant && variant.available);
        btnCustomise.classList.toggle('is-hidden', !purchasable);
      }
    }

    function updateFromVariant(variant) {
      syncStickyButtonStates(variant);
      if (!variant) return;

      bar.setAttribute('data-variant-id', variant.id);

      if (stickyVariantSelect && String(stickyVariantSelect.value) !== String(variant.id)) {
        stickyVariantSelect.value = String(variant.id);
      }

      if (vtoBtn) {
        vtoBtn.setAttribute('data-variant-id', variant.id);
        if (variant.sku) vtoBtn.setAttribute('data-sku', variant.sku);
      }

      if (thumbImg && variant.featured_image && variant.featured_image.src) {
        let src = variant.featured_image.src.replace(/_\d+x\d+\./, '_80x80.').replace(/\?.*$/, '');
        if (src.indexOf('//') === 0) src = `https:${src}`;
        thumbImg.src = src;
      }
    }

    function syncMainFormToVariant(variant) {
      if (!variant || !productForm) return;
      const opts = [variant.option1, variant.option2, variant.option3];
      for (let pos = 1; pos <= 3; pos += 1) {
        const wanted = opts[pos - 1];
        if (wanted == null) continue;

        const selector =
          '.ProductForm__Option [type="radio"][data-option-position="' +
          pos +
          '"][value="' +
          String(wanted).replace(/"/g, '\\"') +
          '"]';
        const radio = productForm.querySelector(selector);
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    function isElementInViewport(el) {
      if (!el) return false;
      const r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && r.top < window.innerHeight && r.bottom > 0;
    }

    function checkVisibility() {
      const anchor = getMainAtcBtn();
      if (!anchor) {
        bar.classList.remove('is-visible');
        setStickyDependentOffsets(false);
        return;
      }

      if (!isElementInViewport(anchor)) {
        bar.classList.add('is-visible');
        setStickyDependentOffsets(true);
      } else {
        bar.classList.remove('is-visible');
        setStickyDependentOffsets(false);
      }
    }

    if (btnCustomise) {
      btnCustomise.addEventListener('click', (e) => {
        e.preventDefault();
        const lensBtn = getMainLensBtn();
        if (lensBtn) lensBtn.click();
      });
    }

    if (btnFrameOnly) {
      btnFrameOnly.addEventListener('click', (e) => {
        const id = parseInt(btnFrameOnly.getAttribute('data-variant-id') || '', 10);
        const v = findVariant(id);
        if (btnFrameOnly.classList.contains('klaviyo-bis-trigger') && (!v || !v.available)) {
          return;
        }

        e.preventDefault();
        const atc = getMainAtcBtn();
        if (atc && !atc.disabled) atc.click();
      });
    }

    if (stickyVariantSelect) {
      stickyVariantSelect.addEventListener('change', () => {
        const nextId = parseInt(stickyVariantSelect.value || '', 10);
        if (!nextId) return;
        const v = findVariant(nextId);
        if (!v) return;
        syncMainFormToVariant(v);
        updateFromVariant(v);
      });
    }

    document.addEventListener('variant:changed', (event) => {
      const variant = event.detail && event.detail.variant ? event.detail.variant : null;
      updateFromVariant(variant);
    });

    window.addEventListener('scroll', checkVisibility, { passive: true });
    window.addEventListener('resize', checkVisibility);
    window.addEventListener('load', checkVisibility);
    checkVisibility();

    const initialId = parseInt(bar.getAttribute('data-variant-id') || '', 10);
    const initialVariant = findVariant(initialId);
    updateFromVariant(initialVariant);
  });
})();

